import type { CSSProperties } from "react";

import { LoggedUser } from "../../models/Person";
import { routes } from "../../routes/routes";
import {
  getBackgroundColor,
  getButtonColor,
  getButtonDisabledColor,
  getButtonTextColor,
  getHeaderTextColor,
  getTextColor,
} from "../../utils/cssVariables";

export type VersionLocationState = {
  from?: string;
};

export const isVersionPath = (path: string) =>
  path === routes.VERSION || path.startsWith(`${routes.VERSION}/`);

export const getVersionReturnPath = (
  state: VersionLocationState | null | undefined,
  user: LoggedUser | null,
): string => {
  if (state?.from && !isVersionPath(state.from)) {
    return state.from;
  }
  if (user && user.id !== 0) {
    return user.isAdmin ? routes.ADMIN_DASHBOARD : routes.DASHBOARD;
  }
  return routes.LOGIN;
};

export const getVersionPageTextColor = () =>
  getHeaderTextColor() === "#fff" ? "#fff" : getTextColor();

export const getVersionPageStyle = (): CSSProperties => {
  const isDarkTheme = getHeaderTextColor() === "#fff";
  const pageTextColor = getVersionPageTextColor();
  const secondaryTextColor = isDarkTheme ? "rgba(255, 255, 255, 0.65)" : getButtonDisabledColor();

  return {
    "--version-bg-color": getBackgroundColor(),
    "--version-text-color": pageTextColor,
    "--version-muted-color": secondaryTextColor,
    "--version-dot-color": isDarkTheme ? "rgba(255, 255, 255, 0.45)" : "#000",
    "--version-border-color": isDarkTheme ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
    "--version-button-color": getButtonColor(),
    "--version-button-text-color": getButtonTextColor(),
  } as CSSProperties;
};

export const formatReleaseDate = (dateStr: string, locale: "en" | "es" = "en") => {
  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) {
    return dateStr;
  }
  return parsed.toLocaleDateString(locale === "es" ? "es" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const versionDetailPath = (version: string) => `/version/${encodeURIComponent(version)}`;
